/* eslint-disable max-len */
import { WordsListTranslations } from '../interfaces/words-list';

const PolishWordsListTranslations: WordsListTranslations = {
  itemsCount: {
    one: '{{n}} pozycja',
    few: '{{n}} pozycje',
    many: '{{n}} pozycji',
  },
  photo: {
    messages: {
      success: 'Dodano zdjęcie',
      error: 'Nie udało się dodać zdjęcia',
    },
  },
  button: {
    create: 'Dodaj listę',
    save: 'Zapisz zmiany',
    saved: 'Zapisano',
    addWord: 'Dodaj',
  },
  save: {
    messages: {
      success: 'Lista została zapisana',
      error: 'Nie udało się zapisać listy',
    },
  },
  add: {
    title: 'Dodaj listę',
    messages: {
      success: 'Dodano nową listę',
      error: 'Nie udało się dodać nowej listy. Spróbuj ponownie za chwilę.',
    },
  },
  edit: {
    title: 'Edycja',
    messages: {
      success: 'Edytowano listę',
      error: 'Nie udało się edytować listy. Spróbuj ponownie za chwilę.',
    },
  },
  share: {
    title: 'Udostępnij',
    description: 'Zaznacz komu chcesz udostępnić listę',
    submit: 'Udostępnij',
    cancel: 'Anuluj',
    messages: {
      success: 'Lista została udostępniona',
      error: 'Nie udało się udostępnić listy',
    },
    students: 'Uczniowie',
    groups: 'Grupy',
    sharedCountTitle: 'Ilu uczniów ma tę listę',
    countOf: '{{n}} z {{total}}',
    emptyGroup: 'pusta',
    loading: 'Ładowanie udostępnień...',
    loadError: 'Błąd podczas ładowania udostępnień',
    shared: 'Udostępniono listę',
    revoked: 'Cofnięto udostępnienie',
    changeError: 'Błąd podczas zmiany udostępnienia',
    groupShared: {
      one: 'Udostępniono {{n}} uczniowi z grupy „{{group}}”',
      few: 'Udostępniono {{n}} uczniom z grupy „{{group}}”',
      many: 'Udostępniono {{n}} uczniom z grupy „{{group}}”',
    },
    groupAllHave: 'Wszyscy z grupy „{{group}}” mają już tę listę',
    groupShareError: 'Nie udało się udostępnić listy grupie',
    groupRevoked: {
      one: 'Cofnięto udostępnienie {{n}} uczniowi z grupy „{{group}}”',
      few: 'Cofnięto udostępnienie {{n}} uczniom z grupy „{{group}}”',
      many: 'Cofnięto udostępnienie {{n}} uczniom z grupy „{{group}}”',
    },
    groupNoneHad: 'Nikt z grupy „{{group}}” nie miał tej listy',
    groupRevokeError: 'Nie udało się cofnąć udostępnienia grupie',
    revokeGroup: {
      title: 'Cofnąć udostępnienie grupie „{{group}}”?',
      losing: 'Lista „{{list}}” zniknie u:',
      alsoOthers: 'Także u tych, którzy dostali ją osobno albo przez inną grupę.',
      ok: 'Cofnij',
    },
    groupCounterHint: 'Licznik przy grupie: ilu jej uczniów ma tę listę — także tych, którzy dostali ją osobno albo przez inną grupę. ',
    savedInstantly: 'Każde kliknięcie zapisuje się od razu.',
  },
  lists: {
    tabs: {
      folders: 'Katalog',
      lists: 'Listy',
    },
    count: 'liczba list',
    itemsTooltip: 'liczba elementów',
    edit: 'Edytuj listę {{list}}',
    editTooltip: 'edytuj listę',
    share: 'Udostępnij listę {{list}}',
    shareTooltip: 'udostępnij',
    delete: 'Usuń listę {{list}}',
    deleteTooltip: 'usuń całą listę',
  },
  studentLists: {
    title: 'Moje listy',
    empty: 'Nie masz jeszcze żadnej listy.',
    emptyHint: 'Gdy nauczyciel udostępni Ci listę, pojawi się tutaj.',
    unavailable: 'Lista „{{list}}” nie jest już dostępna.',
    tooFewWords: 'Lista „{{list}}” ma za mało słów, żeby nią grać.',
  },
  editor: {
    namePlaceholder: 'nazwa listy',
    descriptionPlaceholder: 'opis listy',
    syncing: 'Synchronizacja danych...',
    syncError: 'Błąd synchronizacji danych. Odśwież stronę.',
  },
  editTerm: {
    title: 'Edytuj zwrot',
    termPlaceholder: 'Wpisz termin',
    definitionPlaceholder: 'Wpisz definicję',
    messages: {
      emptyTerm: 'Termin nie może być pusty',
      cannotUpdate: 'Nie można zaktualizować terminu',
      wordRemoved: 'To słowo zostało usunięte z listy, zmiana nie została zapisana',
      error: 'Nie udało się zaktualizować terminu',
    },
  },
  // Podpisy zdjęć z Unsplash: „fot. Autor · Unsplash”, „Zdjęcia: A, B i inni / Unsplash”
  credits: {
    photoBy: 'fot.',
    photosFrom: 'Zdjęcia z',
    photos: 'Zdjęcia:',
    andOthers: ' i inni',
  },
  // Wskazówka w oknie FOTO: quickAdd pogrubione, quickAddRest zaraz po nim
  screenshot: {
    title: 'ZRZUT EKRANU',
    quickAdd: '💡 Szybkie dodawanie',
    quickAddRest: ' — działa tylko wtedy, gdy to okno (FOTO) jest otwarte.',
    noNeedToExpand: 'Tej instrukcji nie trzeba rozwijać.',
    dragStep: '1/ przeciągnij obraz na stronę, w dowolne miejsce',
    pasteStep: '2/ albo skopiuj obraz i wklej go (Ctrl+V, na Macu Cmd+V)',
    instant: 'Obraz od razu trafia do słowa — także wtedy, gdy wkleisz go przypadkiem.',
    shortcuts: 'Skróty klawiszowe do tworzenia zrzutów na urządzeniu: ',
    windows: 'Win + Shift + S  →  zaznacz obszar → wklej (Ctrl+V) na ekranie aplikacji',
    macos: 'Cmd + Shift + 4  →  zaznacz obszar → przesuń wycinek na ekran aplikacji',
    uploading: 'Przesyłanie zrzutu ekranu...',
    uploaded: 'Zrzut ekranu dodany! 🎉',
    uploadError: 'Błąd podczas przesyłania zrzutu ekranu',
  },
  delete: {
    title: 'Usuń',
    description: 'Czy jesteś pewien, że chcesz usunąć tą listę ?',
    submit: 'Usuń',
    cancel: 'Anuluj',
    messages: {
      success: 'Lista została usunięta',
      error: 'Nie udało się usunąć listy',
    },
  },
  images: {
    select: 'FOTO',
    loadFromComputer: 'Załaduj własne zdjęcie',
    findInPhotoBank: 'Pobierz z banku zdjęć',
    morePhotos: 'Więcej zdjęć',
    selectPhoto: 'Wybierz zdjęcie',
    badFormat: 'Możesz wgrywać tylko pliki w formacie JPG lub PNG!',
    tooBig: 'Plik jest za duży! Maksymalny rozmiar to {{mb}}MB.',
    errors: {
      rateLimit: 'Wyczerpany limit wyszukiwania zdjęć. Spróbuj za kilka minut.',
      unavailable: 'Bank zdjęć jest chwilowo niedostępny. Spróbuj za chwilę.',
      notConfigured: 'Wyszukiwanie zdjęć nie jest skonfigurowane w tym środowisku.',
      photoNotFound: 'To zdjęcie zniknęło z banku zdjęć. Wybierz inne.',
      generic: 'Nie udało się pobrać zdjęć. Spróbuj ponownie.',
    },
  },
  catalog: {
    word: {
      add: '★ Do katalogu',
      addHint: 'dodaj do katalogu',
      inCatalog: 'W katalogu',
      unsplash: 'Katalog przyjmuje tylko własne obrazy.',
      noAsset: 'Wgraj ten obraz ponownie, żeby można go było dodać do katalogu.',
      noTerm: 'Uzupełnij zwrot (do 200 znaków).',
    },
    messages: {
      added: 'Dodano do katalogu',
      restored: 'Przywrócono do katalogu',
    },
    fill: {
      button: 'Uzupełnij ({{missing}})',
      hint: 'Kliknij, jeśli brakujące obrazy mają być dodane automatycznie z katalogu obrazów, o ile dany termin/zwrot tam się znajduje. W pozostałych wypadkach należy samodzielnie dodać obraz.',
      success: 'Uzupełniono z katalogu: {{filled}} z {{total}}.',
      empty: 'Katalog nie ma jeszcze obrazów dla tych słów.',
      error: 'Nie udało się pobrać obrazów z katalogu. Spróbuj ponownie.',
    },
    errors: {
      notCurator: 'To konto nie ma uprawnień do katalogu.',
      noTerm: 'Uzupełnij zwrot.',
      sourceNotEligible: 'Katalog przyjmuje tylko własne obrazy.',
      assetNotFound: 'Możesz dodać tylko obraz, który sam wgrałeś.',
      entryExists: 'Ta para już jest w katalogu.',
      entryNotFound: 'Tego wpisu nie ma już w katalogu.',
      generic: 'Coś poszło nie tak. Spróbuj ponownie.',
    },
    entries: {
      title: 'Katalog obrazów',
      search: 'Szukaj w katalogu',
      clearSearch: 'Wyczyść wyszukiwanie',
      termPlaceholder: 'Wpisz słowo lub zwrot pasujący do obrazu',
      imageHint: 'Wklej lub przeciągnij',
      uploadFromDisk: 'Wgraj z dysku',
      uploadError: 'Nie udało się przygotować obrazu. Spróbuj ponownie.',
      add: 'Dodaj do katalogu',
      empty: 'Katalog jest pusty. Dodaj pierwszy obraz powyżej albo przyciskiem „Do katalogu” przy słowie na liście.',
      noMatch: 'Żaden zwrot nie pasuje do wyszukiwania.',
      countTooltip: 'liczba pozycji w katalogu',
      countFilteredTooltip: 'pasujące do wyszukiwania / wszystkie pozycje',
      withdraw: 'Usuń',
      cancel: 'Anuluj',
      withdrawConfirm: 'Usunąć ten obraz z katalogu?\nNauczyciele, którzy już go użyli, zachowają go na swoich listach.',
      withdrawSuccess: 'Usunięto z katalogu',
      editTerm: 'Popraw zwrot',
      editSuccess: 'Poprawiono zwrot',
      mergeTitle: 'Zwrot „{{term}}” jest już w katalogu',
      mergeContent: 'Połączyć oba wiersze? Potem każda poprawka zwrotu przeniesie wszystkie ich obrazy razem.',
      merge: 'Połącz',
      noImage: 'brak obrazu',
      notCurator: 'Ten widok jest dostępny tylko dla kuratorów katalogu.',
    },
  },
  card: {
    active: 'aktywna',
    new: 'nowa',
    tooShort: 'za mało pozycji do gier',
  },
  wordsListForm: {
    labels: {
      name: 'NAZWA',
      description: 'OPIS',
      image: 'grafika',
      words: 'SŁOWA',
      items: 'Pozycje',
      term: 'Zwrot',
      definition: 'Definicja',
      submit: 'Zapisz',
      edit: 'Edytuj',
    },
    info: {
      wordsEmpty: 'Lista jest pusta',
      wordsEmptyHint: 'Pierwszą pozycję dodasz przyciskiem „Dodaj” poniżej.',
      termRequired: 'Bez zwrotu karta nie zostanie zapisana',
      termRequiredSaved: 'Bez zwrotu zmiany w tej karcie nie zostaną zapisane',
    },
    termRequiredModal: {
      titleOne: 'Uzupełnij zwrot w karcie {{cards}}',
      titleMany: 'Uzupełnij zwrot w kartach: {{cards}}',
      content: 'Aby zmiany zostały zapisane, zwrot jest wymagany — wpisz go albo usuń kartę.',
      ok: 'OK',
    },
    validation: {
      name: {
        required: 'Nazwa jest wymagana',
      },
      description: {
        required: 'Opis jest wymagany',
      },
    },
  },
};

export default PolishWordsListTranslations;
